import { useUser } from '@core/user';

import type { UserContextProps } from '@core/user/contexts/User.context';

interface UseMedicalState
  extends Pick<UserContextProps, 'connections' | 'loading'> {}

type UseMedicalReturnType = [UseMedicalState];

export const useMedical = (): UseMedicalReturnType => {
  const [{ connections, loading }] = useUser();

  return [{ connections, loading }];
};
